// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "saude-conectada-2825f.firebaseapp.com",
  "projectId": "saude-conectada-2825f",
  "storageBucket": "saude-conectada-2825f.appspot.com",
  "messagingSenderId": "434392797932",
  "appId": "1:434392797932:web:9cbe171431ec71caa94bc9",
  "measurementId": "G-CNCE85EPQL",
  "apiKey": "AIzaSyBX19qNO1ps--UBTiJKEDmLrRh2XXwQmPM"
};
